import { render } from "./EmailDataContainer.vue?vue&type=template&id=3c2f4492&ts=true"
import script from "./EmailDataContainer.vue?vue&type=script&lang=ts"
export * from "./EmailDataContainer.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__